import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DicomUploadService {
  private apiUrl = environment.pythonUrl; // Your Python backend
  private storedBase64Data: any[] = [];

  constructor(private http: HttpClient) { }

  // Method to get static base64 data from local storage
  getStaticBase64Data(): any[] {
    const storedData = localStorage.getItem('dicomBase64Data');
    return storedData ? JSON.parse(storedData) : [];
  }

  // Method to save base64 data to local storage
  saveStaticBase64Data(data: any[]): void {
    localStorage.setItem('dicomBase64Data', JSON.stringify(data));
  }

  // Method to clear stored base64 data
  clearStaticBase64Data(): void {
    localStorage.removeItem('dicomBase64Data');
  }

  // Method to get image URL from backend
  getImageUrl(filename: string): string {
    return `${this.apiUrl}/view-image/${filename}`;
  }

  // Method to view base64 data (for debugging)
  viewBase64(): any[] {
    const storedData = localStorage.getItem('dicomBase64Data');
    if (!storedData) return [];
    
    const data = JSON.parse(storedData);
    return data.map((item: any) => ({
      fileName: item.fileName,
      base64Preview: item.base64.substring(0, 100) + '...' // Preview first 100 chars
    }));
    
  }


  private extractImageUrl(img: any): string {
    if (img.imageUrl) return img.imageUrl;
    if (img.imageId) return img.imageId;
    // Generate a URL for base64 images
    if (img.base64 && img.base64.startsWith('data:')) {
      return img.base64;
    }
    return '';
  }

  // Add this method to get base64 data for an image
  getBase64ForImage(imageUrl: string): {base64: string, fileName: string} {
    const data = this.storedBase64Data.find(item => item.imageUrl === imageUrl);
    return data || {base64: '', fileName: ''};
  }

  uploadBase64Images(images: any[]): Observable<any> {
    // Store the base64 data for later use
    this.storedBase64Data = images.map(img => ({
      imageUrl: this.extractImageUrl(img),
      base64: img.base64,
      fileName: img.fileName || 'unknown'
    }));
    
    // Then send to backend
    return this.http.post(`${this.apiUrl}/process-base64`, { images });
  }

getMetadata(filename: string) {
  return this.http.post(`${this.apiUrl}/fetch-metadata`, {
    images: [
      {
        base64: '',  // If required by backend, pass empty or needed base64
        fileName: filename
      }
    ]
  });
}
}